(function () {
  function closeAllPopups(section) {
    section.querySelectorAll('.popup_body').forEach(function (body) {
      body.classList.remove('active');
    });

    section.querySelectorAll('.real-upgrade-showcase-video video').forEach(function (video) {
      video.pause();
      video.currentTime = 0;
    });

    section.querySelectorAll('.real-upgrade-showcase-video iframe').forEach(function (iframe) {
      iframe.src = iframe.src;
    });
  }

  function openPopup(section, popup) {
    closeAllPopups(section);
    popup.classList.add('active');

    var video = popup.querySelector('video');
    var iframe = popup.querySelector('iframe');

    if (video) {
      video.play().catch(function () {});
      return;
    }

    if (iframe) {
      var src = iframe.src;
      if (src.indexOf('autoplay=1') === -1) {
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.src = src;
      }
    }
  }

  function initSection(section) {
    if (!section || typeof Swiper === 'undefined') return;

    if (section.realUpgradeShowcaseSwiper) {
      section.realUpgradeShowcaseSwiper.destroy(true, true);
      section.realUpgradeShowcaseSwiper = null;
    }

    var swiperEl = section.querySelector('.real-upgrade-showcase__swiper');
    if (!swiperEl) return;

    var slideCount = section.querySelectorAll('.real-upgrade-showcase__slide').length;
    var prevEl = section.querySelector('.real-upgrade-showcase__nav-btn--prev');
    var nextEl = section.querySelector('.real-upgrade-showcase__nav-btn--next');
    var paginationEl = section.querySelector('.real-upgrade-showcase__progress .swiper-pagination');

    var config = {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 450,
      watchOverflow: true
    };

    if (slideCount > 1) {
      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          type: 'progressbar'
        };
      }

      if (prevEl && nextEl) {
        config.navigation = {
          prevEl: prevEl,
          nextEl: nextEl
        };
      }
    }

    section.realUpgradeShowcaseSwiper = new Swiper(swiperEl, config);

    if (section.realUpgradeShowcaseBound) return;
    section.realUpgradeShowcaseBound = true;

    section.addEventListener('click', function (event) {
      var playTrigger = event.target.closest('[data-showcase-play]');
      if (playTrigger && section.contains(playTrigger)) {
        var popupId = playTrigger.getAttribute('data-showcase-play');
        var popup = section.querySelector('.popup_body[data-id="' + popupId + '"]');
        if (popup) openPopup(section, popup);
        return;
      }

      if (event.target.closest('.popup_close') || event.target.closest('.popup_back')) {
        if (section.contains(event.target)) {
          closeAllPopups(section);
        }
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.real-upgrade-showcase').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.real-upgrade-showcase');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.real-upgrade-showcase');
    if (!section) return;
    closeAllPopups(section);
    if (section.realUpgradeShowcaseSwiper) {
      section.realUpgradeShowcaseSwiper.destroy(true, true);
      section.realUpgradeShowcaseSwiper = null;
    }
    section.realUpgradeShowcaseBound = false;
  });
})();
